import { ApplicationBuilder } from './internals/ApplicationBuilder';
import { ModuleBuilder } from './internals/ModuleBuilder';
export type { ExtractVueContext } from './types/Application';
export type { ExtractVueContextFromFactory } from './types/ModuleDeclaration';

export function createModuleBuilder() {
    return new ModuleBuilder();
}

export function createApplicationBuilder(mainComponent: any) {
    return new ApplicationBuilder(mainComponent);
}
